module.exports = __webpack_public_path__ + "static/img/government_bg3.f5ff82e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/government_bg3.png
// module id = yypJ
// module chunks = 44